import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { usePanelsStore } from "../stores/usePanelsStore.jsx";

function isDocumentHidden() {
  return typeof document !== "undefined" && document.hidden === true;
}

function isNativeRuntime() {
  if (typeof window === "undefined") return false;
  try {
    const platform = String(
      Capacitor?.getPlatform?.() || window?.Capacitor?.getPlatform?.() || ""
    ).toLowerCase();
    return (
      platform === "ios" ||
      platform === "android" ||
      Capacitor?.isNativePlatform?.() === true ||
      window?.Capacitor?.isNativePlatform?.() === true ||
      typeof window?.webkit?.messageHandlers?.nativeBridge?.postMessage === "function"
    );
  } catch {
    return false;
  }
}

export function useBackgroundIdle() {
  const isRecording = usePanelsStore((s) => !!s.isRecording);
  const [hidden, setHidden] = useState(isDocumentHidden);
  const nativeRuntime = isNativeRuntime();
  const [nativeActive, setNativeActive] = useState(true);

  useEffect(() => {
    const update = () => setHidden(isDocumentHidden());
    update();
    if (typeof document === "undefined") return undefined;
    document.addEventListener("visibilitychange", update);
    return () => document.removeEventListener("visibilitychange", update);
  }, []);

  useEffect(() => {
    if (!nativeRuntime) return undefined;
    let disposed = false;
    let subscription = null;

    import("@capacitor/app")
      .then(async ({ App }) => {
        try {
          const state = await App.getState?.();
          if (!disposed && typeof state?.isActive === "boolean") {
            setNativeActive(state.isActive);
          }
        } catch {}
        try {
          subscription = await App.addListener?.("appStateChange", ({ isActive }) => {
            if (!disposed) setNativeActive(isActive === true);
          });
        } catch {}
      })
      .catch(() => {});

    return () => {
      disposed = true;
      try {
        subscription?.remove?.();
      } catch {}
    };
  }, [nativeRuntime]);

  return (nativeRuntime ? !nativeActive : hidden) && !isRecording;
}

export function isBackgroundIdleNow() {
  try {
    if (isNativeRuntime()) return false;
    return isDocumentHidden() && !usePanelsStore.getState()?.isRecording;
  } catch {
    return false;
  }
}
